import React from "react";
import DemoNavbar from "components/Navbars/DemoNavbar.jsx";
import CardsFooter from "components/Footers/CardsFooter";
import ChildPageBanner from "./layout/ChildPageBanner";
import BusinessImpactSection from "./layout/BusinessImpactSection";
import CapabilityCardsSection from "./layout/CapabilityCardsSection";

const banner = {
  background: "banner/engineering.png",
  Title: "OUR BUSINESS",
  childTitle: "ENGINEERING &<br/>INFRASTRUCTURE",
  desktopCol: "8",
}

const impactSection = {
  titleLines: [
    "INDUSTRIAL ENGINEERING &",
    "AUTOMATION"
  ],
  paragraphs: [
    "Engineering the Future of Industrial Development",
    "HMG supports complex infrastructure and industrial projects through integrated engineering, procurement, construction, automation, and technology-led project coordination.",
    "Working with specialized engineering firms, EPC contractors, network specialists, and technology partners, we structure and deliver tailored solutions for government-linked entities, national enterprises, industrial developers, energy operators, and private-sector clients across Asia and international markets.",
    "Our platform connects strategic sourcing, technical expertise, project execution, and market access—enabling partners to move seamlessly from concept and procurement through deployment, commissioning, and long-term operational support."
  ],
  image: "content/engineering-automation-hero.png",
  imageAlt: "Engineering and industrial infrastructure"
};

const coreCapabilities = [
  {
    number: "01",
    title: "RENEWABLE ENERGY & SMART GRID INFRASTRUCTURE",
    image: "content/energy4.png"
  },
  {
    number: "02",
    title: "CABLE & POWER INFRASTRUCTURE",
    image: "content/engineeringa1.1-dark.png"
  },
  {
    number: "03",
    title: "AUTOMATION & SMART ENGINEERING",
    image: "content/engineeringa2.1-dark.png"
  },
  {
    number: "04",
    title: "POWER PLANT & INDUSTRIAL ENGINEERING",
    image: "content/engineeringa1.jpg"
  },
  {
    number: "05",
    title: "CIVIL & STRATEGIC INFRASTRUCTURE",
    image: "content/engineering3.png"
  },
  {
    number: "06",
    title: "END-TO-END EPC COORDINATION",
    image: "content/engineeringa3.jpg"
  }
];

class EngineeringInfrastructure extends React.Component {
  render() {
    return (
      <>
        <DemoNavbar />
        <main className="food commodity-supply-chain-page engineering-infrastructure-page" ref="main">
          <ChildPageBanner banner={banner} />
          <BusinessImpactSection {...impactSection} />
          <CapabilityCardsSection
            heading="CORE CAPABILITIES"
            capabilities={coreCapabilities}
            gridClassName="supply-chain-capabilities-grid--six"
          />
        </main>
        <CardsFooter />
      </>
    );
  }
}

export default EngineeringInfrastructure;
